<template>
  <div>
    <a-popover v-if="!loading && hasContactDetails"
               v-model="visible" trigger="click hover">
      <template slot="content">
        <div class="flex-row gap-md">

          <div class="flex-col justify-content-center">
            <img v-if="agencyLogo" :src="agencyLogo" alt="logo"/>
            <dd-icon v-else icon="mdi mdi-domain" size="xxl" class="color-primary"/>
          </div>

          <div class="flex-col">

            <div class="flex-row gap-sm align-items-center">
              <phone-icon/>
              <div v-if="agency.phone" class="flex-row width-stretch gap-xs align-items-center">
                <span class="flex-stretch">{{agency.phone}}</span>
                <dd-icon-button
                    @click="callNumber"
                    icon="mdi mdi-phone"
                    size="lg"
                    class="mb-xxs"
                    style="width: 30px; height: 30px"
                />
              </div>
              <span v-else> niet beschikbaar</span>
            </div>

            <div class="flex-row gap-sm align-items-center">
              <email-icon/>
              <span>{{ agency.email || ' niet beschikbaar' }}</span>
            </div>

            <div class="flex-row gap-sm align-items-center">
              <dd-icon icon="mdi mdi-web" size="sm" style="width: 14px"/>
              <dd-button
                  v-if="agency.extranet_url"
                  small
                  class="mt-xxs width-stretch"
                  @click="openPortal"
              >
                <span class="width-stretch align-items-center">open portaal</span>
              </dd-button>
              <span v-else> niet beschikbaar</span>
            </div>
          </div>

          <div>
            <a :href="agency.agency_url">
              <i class="mdi mdi-pencil color-black"/>
            </a>
          </div>

        </div>

      </template>

      <span class="color-primary">
        {{ agency.name || 'Onbekend' }}
        <information-outline-icon title="Info" class="contact-details-info-icon"/>
      </span>
    </a-popover>

    <span v-if="!loading && !hasContactDetails">Onbekend</span>
  </div>
</template>

<script>
import axios from "~/plugins/axios";
import ContactDetailsComponent from "~/components/ContactDetailsComponent.vue";
import agencyApi from "~/api/agency";
import voipApi from "~/api/voip";

export default {
  name: "agencyContactDetailsComponent",
  components: {
    ContactDetailsComponent,
  },
  props: {
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  async created() {
    if (this.id !== null && this.id !== '' && this.id !== undefined) {
      await this.getAgencyContactDetails();
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      agency: {
        id: null,
        logo: null,
        name: null,
        subtitle: null,
        phone: null,
        email: null,
        extranet_url: null
      },
      agencyLogo: null
    };
  },
  methods: {
    async getAgencyContactDetails() {
      this.loading = true;
      await agencyApi.find(this.id, ['logo']).then((response) => {
        this.agency = response.data;

        if (response.data.logo
          && response.data.logo.data
          && response.data.logo.data.mime_type
          && response.data.logo.data.content) {
          const mimeType = response.data.logo.data.mime_type;
          const content = response.data.logo.data.content;

          this.agencyLogo = `data:${mimeType};base64,${content}`;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    callNumber() {
      voipApi.outgoingCall(this.agency.phone).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis tijdens het uitbellen.',
        });
      });
    },
    openPortal(){
      let url = this.agency.extranet_url;
      if (url.search('http://') < 0 && url.search('https://') < 0 ) {
        url = 'https://' + url;
      }
      this.navigator.openPath(url);
    }
  },
  computed: {
    hasContactDetails() {
      return this.agency.name !== null ||
             this.agency.email !== null ||
             this.agency.phone !== null ||
             this.agency.extranet_url !== null;
    }
  },
}
</script>

<style>
  img {
    max-width: 150px;
  }
  .ant-popover-inner-content{
    padding: 8px;
  }
</style>